//脱法さんそさんテンプレート
import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import { Platform } from '@/firebase/firestore/Platform'
import { Sex } from '@/firebase/firestore/Sex'
import { VoiceChat } from '@/firebase/firestore/VoiceChats'
import Image from 'next/image'
import fitty from 'fitty'

type Props = {
  targetId: string
  templateColor: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7
  uid: string
  name: string
  sex: Sex
  platform: Array<Platform>
  voiceChat: Array<VoiceChat>
  playStyle: string
  fontFamily: string
  fontColor: string
  apexFavoriteWeapon: string
  hitokoto: string
  legends: number[]
}

export const Apex4: React.FC<Props> = ({
  uid,
  name,
  sex,
  fontFamily,
  fontColor,
  playStyle,
  platform,
  templateColor,
  voiceChat,
  apexFavoriteWeapon,
  hitokoto,
  legends,
  targetId,
}) => {
  useEffect(() => {
    fitty('#name', {
      maxSize: 18,
      minSize: 6,
    })
    fitty('#apexId', {
      maxSize: 16,
      minSize: 6,
    })
    fitty('#playStyle', {
      maxSize: 18,
      minSize: 9,
    })
    fitty('#favoriteWeapon', {
      maxSize: 18,
      minSize: 9,
    })
    fitty('#hitokoto', {
      maxSize: 18,
      minSize: 14,
    })
  }, [])
  return (
    <Container id={targetId} fontFamily={fontFamily} fontColor={fontColor}>
      <Image
        width="1280"
        height="868"
        priority={true}
        unoptimized={true}
        alt={`Apex自己紹介カード ${templateColor}`}
        src={`/static/images/profiles/apex4/${templateColor}-min.jpg`}
      />
      <Name>
        <span id="name">{name}</span>
      </Name>
      <Id>
        <span id="apexId">{uid}</span>
      </Id>
      {sex === 0 && <Sex0 />}
      {sex === 1 && <Sex1 />}
      {sex === 2 && <Sex2 />}
      {platform.includes(0) && <Platform0 />}
      {platform.includes(1) && <Platform1 />}
      {platform.includes(2) && <Platform2 />}
      {platform.includes(3) && <Platform3 />}
      {voiceChat.includes(0) && <VC0 />}
      {voiceChat.includes(1) && <VC1 />}
      {voiceChat.includes(2) && <VC2 />}
      {voiceChat.includes(3) && <VC3 />}
      {voiceChat.includes(4) && <VC4 />}
      {legends.includes(0) && <Legend0 />}
      {legends.includes(1) && <Legend1 />}
      {legends.includes(2) && <Legend2 />}
      {legends.includes(3) && <Legend3 />}
      {legends.includes(4) && <Legend4 />}
      {legends.includes(5) && <Legend5 />}
      {legends.includes(6) && <Legend6 />}
      {legends.includes(7) && <Legend7 />}
      {legends.includes(8) && <Legend8 />}
      {legends.includes(9) && <Legend9 />}
      {legends.includes(10) && <Legend10 />}
      {legends.includes(11) && <Legend11 />}
      {legends.includes(12) && <Legend12 />}
      {legends.includes(13) && <Legend13 />}
      {legends.includes(14) && <Legend14 />}
      {legends.includes(15) && <Legend15 />}
      {legends.includes(16) && <Legend16 />}
      {legends.includes(17) && <Legend17 />}
      {legends.includes(18) && <Legend18 />}
      {legends.includes(19) && <Legend19 />}
      {legends.includes(20) && <Legend20 />}
      {legends.includes(21) && <Legend21 />}
      {legends.includes(22) && <Legend22 />}
      {legends.includes(23) && <Legend23 />}
      <FavoriteWeapon>
        <span id="favoriteWeapon">{apexFavoriteWeapon}</span>
      </FavoriteWeapon>
      <Hitokoto>
        <span id={'hitokoto'}>{hitokoto}</span>
      </Hitokoto>
      <PlayStyle>
        <span id="playStyle">{playStyle}</span>
      </PlayStyle>
    </Container>
  )
}

const Container = styled.div<{ fontFamily: string; fontColor: string }>`
  position: relative;
  width: 100%;
  line-height: 0;
  * {
    line-height: 1;
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ fontColor }) => fontColor};
    border-color: ${({ fontColor }) => fontColor};
  }
`

const Name = styled.div`
  position: absolute;
  top: 20%;
  left: 4%;
  width: 36%;
  height: 7%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: 12px;
    font-weight: bold;
  }
`

const Id = styled.div`
  position: absolute;
  top: 35%;
  left: 4%;
  width: 36%;
  display: flex;
  align-items: center;
  text-align: center;

  span {
    font-weight: bold;
    line-height: 13px;
  }
`

const SexBase = styled.div`
  position: absolute;
  top: 25%;
  left: 27.2%;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  width: 18px;
  height: 18px;
`

const Sex0 = styled(SexBase)``
const Sex1 = styled(SexBase)`
  left: 32%;
`
const Sex2 = styled(SexBase)`
  left: 37%;
`

const PlatformBase = styled.div`
  position: absolute;
  top: 44.5%;
  left: 10.5%;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  width: 24px;
  height: 24px;
`

const Platform0 = styled(PlatformBase)``
const Platform1 = styled(PlatformBase)`
  left: 16%;
`
const Platform2 = styled(PlatformBase)`
  left: 21.8%;
`

const Platform3 = styled(PlatformBase)`
  left: 27.5%;
`

const VCBase = styled.div`
  position: absolute;
  top: 56.5%;
  left: 7.8%;
  border-style: solid;
  border-width: 2px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
`

const VC0 = styled(VCBase)``
const VC1 = styled(VCBase)`
  left: 13.4%;
`
const VC2 = styled(VCBase)`
  left: 19%;
`
const VC3 = styled(VCBase)`
  left: 24.5%;
`
const VC4 = styled(VCBase)`
  left: 30%;
`

const PlayStyle = styled.div`
  position: absolute;
  top: 72%;
  left: 4%;
  width: 36%;
  height: 7%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    font-weight: bold;
    line-height: 0.9;
  }
`

const FavoriteWeapon = styled.div`
  position: absolute;
  top: 84%;
  left: 4%;
  text-align: center;
  width: 36%;
  word-break: break-all;
  height: 12%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    font-weight: bold;
    line-height: 0.9;
  }
`

const Hitokoto = styled.div`
  position: absolute;
  top: 72%;
  left: 44%;
  height: 22%;
  width: 50%;
  word-break: break-all;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
    line-height: 1.3;
  }
`

const LegendBase = styled.div`
  position: absolute;
  top: 6.2%;
  left: 43%;
  border-style: solid;
  border-width: 3px;
  border-radius: 50%;
  width: 39px;
  height: 39px;
`

const Legend0 = styled(LegendBase)``
const Legend1 = styled(LegendBase)`
  left: 51.8%;
`
const Legend2 = styled(LegendBase)`
  //ライフライン
  left: 60.5%;
`
const Legend3 = styled(LegendBase)`
  left: 69.2%;
`
const Legend4 = styled(LegendBase)`
  left: 78%;
`
const Legend5 = styled(LegendBase)`
  left: 87%;
`
const Legend6 = styled(LegendBase)`
  //ガス
  top: 20%;
  left: 43%;
`
const Legend7 = styled(LegendBase)`
  top: 20%;
  left: 51.8%;
`
const Legend8 = styled(LegendBase)`
  top: 20%;
  left: 60.5%;
`
const Legend9 = styled(LegendBase)`
  top: 20%;
  left: 69.2%;
`

const Legend10 = styled(LegendBase)`
  //クリプト
  top: 20%;
  left: 78%;
`

const Legend11 = styled(LegendBase)`
  top: 20%;
  left: 87%;
`

const Legend12 = styled(LegendBase)`
  //ローバ
  top: 35%;
  left: 43%;
`

const Legend13 = styled(LegendBase)`
  top: 35%;
  left: 51.8%;
`

const Legend14 = styled(LegendBase)`
  top: 35%;
  left: 60.5%;
`

const Legend15 = styled(LegendBase)`
  //ヒューズ
  top: 35%;
  left: 69.2%;
`

const Legend16 = styled(LegendBase)`
  top: 35%;
  left: 78%;
`

const Legend17 = styled(LegendBase)`
  top: 35%;
  left: 87%;
`

const Legend18 = styled(LegendBase)`
  top: 51%;
  left: 43%;
`

const Legend19 = styled(LegendBase)`
  top: 51%;
  left: 51.8%;
`

const Legend20 = styled(LegendBase)`
  top: 51%;
  left: 60.5%;
`

const Legend21 = styled(LegendBase)`
  //ヴァンテージ
  top: 51%;
  left: 69.2%;
`

const Legend22 = styled(LegendBase)`
  top: 51%;
  left: 78%;
`

const Legend23 = styled(LegendBase)`
  //ヴァンテージ
  top: 51%;
  left: 86.5%;
`
